// extracted by mini-css-extract-plugin
export default {"lockerLegend":"DoorsPerLockerBySize-lockerLegend-c630","legendLabel":"DoorsPerLockerBySize-legendLabel-d7d3","legendTitle":"DoorsPerLockerBySize-legendTitle-fcde"};